import { Link } from "react-router-dom";
import { Fragment } from "react";

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumbs({ items }: { items: Crumb[] }): JSX.Element {
  return (
    <nav className="mb-4 flex items-center gap-1.5 text-sm text-slate-500 dark:text-slate-400" aria-label="Breadcrumb">
      {items.map((item, idx) => (
        <Fragment key={idx}>
          {idx > 0 && <span className="text-slate-300 dark:text-slate-600">/</span>}
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-brand-600 dark:hover:text-brand-400">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-slate-700 dark:text-slate-200">{item.label}</span>
          )}
        </Fragment>
      ))}
    </nav>
  );
}
